import {
  AccountFilter,
  AccountTypeFilter,
  BookingChannelFilter,
  BookFilter,
  ClassificationFilter,
  ContactsFilter,
  ListingsFilter,
  PartyFilter,
} from '@vrplatform/table-filter';

export {
  AccountFilter,
  AccountTypeFilter,
  BookingChannelFilter,
  BookFilter,
  ClassificationFilter,
  ContactsFilter,
  ListingsFilter,
  PartyFilter,
} from '@vrplatform/table-filter';

export const CustomFilter = {
  BookingChannel: BookingChannelFilter,
  Book: BookFilter,
  Listings: ListingsFilter,
  Contacts: ContactsFilter,
  Party: PartyFilter,
  AccountType: AccountTypeFilter,
  Account: AccountFilter,
  Classification: ClassificationFilter,
};
